import React from "react";
import { Chip } from "@mui/material";

import { JOB_STATUSES } from "../../constants";

const flow = {
  [JOB_STATUSES.NOT_STARTED]: { color: "grey" },
  [JOB_STATUSES.IN_PROGRESS]: { color: "blue" },
  [JOB_STATUSES.COMPLETE]: { color: "green" },
};
const sx = {
  "& .MuiChip-label": {
    fontSize: 10,
    fontWeight: 500,
  },
  my: "-4px",
};

const OutboundOrdersStatusChip = ({ item }) => {
  const label = item?.completionDate
    ? JOB_STATUSES.COMPLETE
    : item?.shipDate
    ? JOB_STATUSES.IN_PROGRESS
    : JOB_STATUSES.NOT_STARTED;

  const final = flow[label];

  return <Chip label={label} variant="colorTag" flow={final.color} sx={sx} />;
};

export default OutboundOrdersStatusChip;
